import * as React from "react";
import { toast, ToastContainer } from "react-toastify";
import withServices from "../../../../HOCs/withServices";
import NavBar from "../../../../components/CustomNav/CustomNav.Component";
import DatePicker from "../../../../components/DatePicker/DatePickerComponent";
import schoolBg from "../../../../assets/images/parentreg/schoolbg.jpg";

import {
  Container,
  FormContainer,
  FormWrapper,
} from "../../Common/Common.styles";
import {
  Heading,
  InputWrapper,
} from "./SchoolRegistration.styles";

import { Row, Section, Col2, TooltipParagraph } from '../../Parent/Registration/ParentRegistration.styles'

import { currentBaseUrl, saveItem } from '../../../../common/services';
import {
  CURRENTUSERID,
  CURRENTUSERNAME,
  PROFILEKEY,
  SUBSCRIPTIONKEY,
  TOKENKEY,
  CURRENTDESIGNATION,
} from "../../../../common/constants";


interface IProps {
  services?: any;
  history?: any;
  match?: any;
}

class SchoolRegistration extends React.Component<IProps> {
  public state = {
    password: "",
    institutiontype: null,
    email: "",
    schoolname: "",
    phone: "",
    dateObj: null as any,
    schoolyear: null,
    startDate: "",
    institutionTypes: [] as any,
  };
  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this);
    this.registerSchool = this.registerSchool.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchUserInfo = this.fetchUserInfo.bind(this);
    this.registerSchool = this.registerSchool.bind(this);
  }

  public async componentDidMount() {
    const {
      history,
      services: {
        isUserLoggedIn,
        institutionsAPI,
        currentBaseUrl,
        currentDesignation,
        isUserUpgraded,
      },
    } = this.props;

    if (isUserLoggedIn) {
      if (isUserUpgraded) {
        this.navigate("school/home");
      }
    }

    const typesRes = await institutionsAPI.getInstitutionTypes();
    if (typesRes.ok) {
      const institutionTypes = typesRes.data.types;
      this.setState({ institutionTypes });
    }
  }
  public handleChange(event) {
    const currentField = event.target.dataset.arg;
    this.state[currentField] = event.target.value;
  }
  public ageChangeHandler = (dateObj) => {
    const startDate = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ dateObj, startDate });
  };
  public navigate(destination) {
    const { history } = this.props;
    history.push(destination);
  }

  public async registerSchool(event) {
    event.preventDefault();
    const {
      email,
      schoolname,
      password,
      schoolyear,
      startDate,
      institutiontype,
    } = this.state;

    const item = {
      academic_year_length: schoolyear,
      calendar_start_date: startDate,
      email,
      institution_type: institutiontype,
      password,
      school_name: schoolname,
    };

    const packageID = this.props.match.params.packageid;
    let regRes;
    if (typeof packageID === "undefined") {
      regRes = await this.props.services.institutionsAPI.registerInstitutionGeneric(
        item
      );
    } else {
      alert(JSON.stringify({ ...item, selected_package: +packageID }, null, 4));
      regRes = await this.props.services.institutionsAPI.registerInstitutionMarketing(
        { ...item, selected_package: +packageID }
      );
    }
    if (regRes.ok) {
      saveItem(PROFILEKEY, regRes.data.profile);
      saveItem(SUBSCRIPTIONKEY, regRes.data.subscription);
      saveItem(TOKENKEY, regRes.data.token);
      saveItem(CURRENTDESIGNATION, regRes.data.designation);
      saveItem(PROFILEKEY, regRes.data.profile);
      saveItem(CURRENTUSERNAME, regRes.data.userinfo.username);
      saveItem(CURRENTUSERID, regRes.data.userinfo.id);
      this.props.history.push(`${currentBaseUrl()}purchase${typeof packageID === 'undefined' ? '' : '/'+packageID }`)
    } else {
      toast.error("Sign up failed, check your details!");
    }
  }

  public async fetchUserInfo() {
    // coming
    const infoRes = await this.props.services.adminAPI.fetchUserInfo();
    if (infoRes.ok) {
      // breakdown
    } else {
      window.location.reload();
    }
  }

  public render() {
    const { institutionTypes } = this.state;
    return (
      <Container background={schoolBg}>
        <ToastContainer />
        <NavBar />
        <Section
          backgroundImage="linear-gradient(45deg, rgba(172, 255, 36, 0.85), rgba(62, 233, 247, 0.85))"
          height="100%"
          justify="center"
        >
          <Row
            style={{ maxWidth: "1024px", boxShadow: "10px 10px 64px #0a0a0a" }}
            wrap={true}
            width="80%"
            justify="center"
          >
            <Col2 height="760px" background={schoolBg}>
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: "#00000085",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-end",
                  padding: "2em",
                  minWidth: "400px",
                }}
              >
                <Heading style={{ textAlign: "left" }}>
                  It's time for you to register.
                </Heading>
              </div>
            </Col2>
            <Col2 height="760px">
              <FormContainer>
                <FormWrapper width="100%">
                  {/* <img className="logo" src={logo} alt="PLEX" /> */}
                  <p
                    style={{
                      textAlign: "left",
                      fontSize: "30px",
                      width: "100%",
                      padding: "0 16px",
                    }}
                    className="designation-title"
                  >
                    Register School
                  </p>
                  <form onSubmit={this.registerSchool}>
                    <InputWrapper>
                      <TooltipParagraph>
                        Who would you like Performance Learning for?
                        <a href="#">Multiple year groups?</a>
                        <span className="hover-tooltip">
                          Pick one year group, you can register learners with
                          different year groups in Performance Learning itself (Performance Learning will show
                          you how).
                        </span>
                      </TooltipParagraph>
                      <select
                        name="type"
                        data-arg="institutiontype"
                        required={true}
                        className="custom-select"
                        placeholder="Please choose your type of institution"
                        onChange={this.handleChange}
                      >
                        <option value="">Who would you like Performance Learning for?</option>
                        {institutionTypes.map((el) => (
                          <option value={el.id} key={`type-${el.id}`}>
                            {el.Name}
                          </option>
                        ))}
                      </select>
                    </InputWrapper>

                    <InputWrapper>
                      <p>Email</p>
                      <input
                        type="email"
                        id="email"
                        className="custom-textfield"
                        placeholder="Email Address"
                        required={true}
                        data-arg="email"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>

                    <InputWrapper>
                      <p>Institution Name</p>
                      <input
                        type="text"
                        id="schoolname"
                        className="custom-textfield"
                        placeholder="School Name"
                        required={true}
                        data-arg="schoolname"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>

                    <InputWrapper>
                      <p>Password</p>
                      <input
                        type="password"
                        id="password"
                        className="custom-textfield"
                        placeholder="Password"
                        required={true}
                        data-arg="password"
                        onChange={this.handleChange}
                      />
                    </InputWrapper>
                    <InputWrapper>
                      <p>WHEN DOES YOUR ACADEMIC YEAR START?</p>
                      <DatePicker
                        value={this.state.dateObj}
                        onChange={this.ageChangeHandler}
                        placeholder="When does your academic year start?"
                      />
                    </InputWrapper>

                    <InputWrapper>
                      <p>HOW MANY MONTHS IS YOUR TYPICAL ACADEMIC YEAR?</p>
                      <input
                        type="number"
                        id="schoolyear"
                        className="custom-textfield"
                        placeholder="How may months is your typical academic year?"
                        required={true}
                        data-arg="schoolyear"
                        onChange={this.handleChange}
                        min="0"
                      />
                    </InputWrapper>

                    <button
                      style={{ color: "#000", width: "100%" }}
                      className="green-button register-parent"
                      type="submit"
                    >
                      Register
                    </button>
                    <p className="already-registered">
                      ALREADY REGISTERED?{" "}
                      <span onClick={this.navigate.bind(this, "/login")}>
                        LOGIN HERE
                      </span>
                    </p>
                  </form>
                </FormWrapper>
              </FormContainer>
            </Col2>
          </Row>
        </Section>
      </Container>
    );
  }
}

export default withServices(SchoolRegistration);



// WEBPACK FOOTER //
// ./src/pages/Onboard/Institution/Registration/SchoolRegistration.tsx